import {Cloneable} from "@/common/Cloneable";
import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Schema} from "@/common/Schema";
import {SmartOfferBundleAlchemyLevelCauldronKind} from "@/modules/redactor/models/smart-offer/bundle-alchemy/SmartOfferBundleAlchemyLevelCauldronKind";

export class SmartOfferBundleAlchemyLevel extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(SmartOfferBundleAlchemyLevel, v) : SKIP;
            },
            (v) => {
                return deserialize(SmartOfferBundleAlchemyLevel, v);
            }
        );
    }

    constructor() {
        super();
        this._colors = 0;
        this._cauldron = SmartOfferBundleAlchemyLevelCauldronKind.NONE;
        this._show_extra_rewards = false;
    }

    get colors() {
        return this._colors;
    }
    set colors(value) {
        this._colors = value;
    }

    get cauldron() {
        return this._cauldron;
    }
    set cauldron(value) {
        this._cauldron = value;
    }

    get show_extra_rewards() {
        return this._show_extra_rewards;
    }
    set show_extra_rewards(value) {
        this._show_extra_rewards = value;
    }

    valid() {
        return this.colors != 0 && !SmartOfferBundleAlchemyLevelCauldronKind.isNone(this.cauldron);
    }

    empty() {
        return this.colors == 0 || SmartOfferBundleAlchemyLevelCauldronKind.isNone(this.cauldron);
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleAlchemyLevel());
        } else if (target instanceof SmartOfferBundleAlchemyLevel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleAlchemyLevel, {
    _colors: alias("colors", Schema.primitive()),
    _cauldron: alias("cauldron", SmartOfferBundleAlchemyLevelCauldronKind.schema()),
    _show_extra_rewards: alias("show_extra_rewards", Schema.primitive()),
});
